<template>
  <div>
    <div class="standart-page">
      <div class="row justify-content-center mb-4">
        <div class="col-5 d-flex justify-content-center">
          <Can I="read" a="/dagitim/Dagitim">
            <button class="btn btn-block mr-2 mt-0" :class="activeTab === 0 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(0, 'DagitimDetay')">
              Dağıtım Detay
            </button>
          </Can>
          <Can I="read" a="/dagitim/Dagitim">
            <button class="btn btn-block mr-2 mt-0" :class="activeTab === 1 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(1, 'Dagitim')">
              Dağıtımlar
            </button>
          </Can>
        </div>
      </div>
      <component :is="$store.state.dagitim.currentTab" />
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    ...mapActions('dagitim', ["changeDetailTab"]),
    changeComponent(id, cmp) {
      this.activeTab = id;
      this.changeDetailTab(cmp);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created() {
    if(this.$store.state.auth.user.memberId || this.$store.state.auth.user.memberId > 0){
      this.changeComponent(2, "DagitimDetayUye");
    }else{
      this.changeComponent(0, "DagitimDetay");
    }
  },
  watch: {},
  computed: {
    ...mapGetters("general", ["getMessage"]),
  }
};
</script>